import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import { formatCurrencyAmount } from "../../../../../helpers/formatAmount";

export const TaxProjectionOverview = ({ data }) => {
  if (!data) return <div>No data available</div>;

  const [activeTab, setActiveTab] = useState("tableView");

  const projections = data && data.projections ? data.projections : [];
  const chartData = data && data.chartData ? data.chartData : {};
  const capitalGains = data && data.capitalGains ? data.capitalGains : {};

  // ✅ Prepare Chart Dataset
  const lineChartData = {
    labels: chartData.labels || [],
    datasets: [
      {
        label: "Federal Tax",
        data: chartData.datasets ? chartData.datasets.federal : [],
        borderColor: "#C9D5F1",
        backgroundColor: "#C9D5F1",
        tension: 0.3,
        fill: true,
        order: 3,
      },
      {
        label: "State Tax",
        data: chartData.datasets ? chartData.datasets.state : [],
        borderColor: "#E53E3E",
        backgroundColor: "#E53E3E",
        tension: 0.3,
        fill: true,
        order: 2,
      },
      {
        label: "Total Tax",
        data: chartData.datasets ? chartData.datasets.total : [],
        borderColor: "#2A3DA3",
        backgroundColor: "#2A3DA3",
        tension: 0.3,
        fill: true,
        order: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      tooltip: { mode: "index", intersect: false },
    },
    interaction: { mode: "nearest", intersect: false },
    scales: {
      yAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)", // Make grid lines invisible
          },
          title: { display: true, text: "Tax ($)" },
          ticks: { callback: (v) => `$${v.toLocaleString()}` },
        },
      ],
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)", // Make grid lines invisible
          },
          title: { display: true, text: "Year" },
        },
      ],
    },
  };

  return (
    <div
      className="social-security-main"
      style={{ width: "100%", padding: "1rem 3rem" }}
    >
      <div className="social-security-toggle-container">
        <div
          className={`social-security-toggle-button-container ${
            activeTab === "tableView" ? "active" : ""
          }`}
        >
          <button
            className={`social-security-toggle-button ${
              activeTab === "tableView" ? "active" : ""
            }`}
            onClick={() => setActiveTab("tableView")}
          >
            Detailed Table
          </button>
        </div>
        <div
          className={`social-security-toggle-button-container ${
            activeTab === "graphView" ? "active" : ""
          }`}
        >
          <button
            className={`social-security-toggle-button ${
              activeTab === "graphView" ? "active" : ""
            }`}
            onClick={() => setActiveTab("graphView")}
          >
            Tax Trend Graph
          </button>
        </div>
      </div>
      <h2 className="text-xl font-semibold text-gray-800 mb-4 mt-4">
        Tax Projection Overview
      </h2>

      {/* Graph View */}
      {activeTab === "graphView" && (
        <div className="bg-white rounded-2xl p-4">
          <Line height={90} data={lineChartData} options={options} />
        </div>
      )}

      {/* Table View */}
      {activeTab === "tableView" && (
        <div
          style={{
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "rgb(244, 247, 254)",
                  position: "sticky",
                  top: 0,
                }}
              >
                <th style={thStyle}>Year</th>
                <th style={thStyle}>Income ($)</th>
                <th style={thStyle}>Federal Tax ($)</th>
                <th style={thStyle}>State Tax ($)</th>
                <th style={thStyle}>Refundable Credits ($)</th>
                <th style={thStyle}>Non-Refundable Credits ($)</th>
                <th style={thStyle}>Initial Tax ($)</th>
                <th style={thStyle}>Total Tax ($)</th>
                <th style={thStyle}>Tax Liability ($)</th>
                <th style={thStyle}>Effective Rate (%)</th>
                <th style={thStyle}>Marginal Rate (%)</th>
              </tr>
            </thead>
            <tbody>
              {projections &&
                projections.map(function (p, i) {
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                      <td style={tdStyle}>{p.year}</td>
                      <td style={tdStyle}>{formatCurrencyAmount(p.income)}</td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(
                          p.federal && p.federal.tax ? p.federal.tax : 0
                        )}
                      </td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(
                          p.state && p.state.tax ? p.state.tax : 0
                        )}
                      </td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(
                          p.credits && p.credits.refundable
                            ? p.credits.refundable
                            : 0
                        )}
                      </td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(
                          p.credits && p.credits.nonRefundable
                            ? p.credits.nonRefundable
                            : 0
                        )}
                      </td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(p.initialTax)}
                      </td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(p.totalTax)}
                      </td>
                      <td style={tdStyle}>
                        {formatCurrencyAmount(p.totalTaxLiability)}
                      </td>
                      <td style={tdStyle}>
                        {p.effectiveRate ? p.effectiveRate + "%" : "N/A"}
                      </td>
                      <td style={tdStyle}>
                        {p.marginalRate ? p.marginalRate + "%" : "N/A"}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}

      {/* Capital Gains Section */}

      {/*<div style={{ marginTop: "2rem", width: "50%" }}>
        <h3 className="text-lg font-semibold mb-2">Capital Gains Summary</h3>
        <div className="social-security-calultor-results">
          <div className="social-result-heading">Net Capital Gain:</div>
          <div className="social-result-value">
            {capitalGains.netCapitalGain &&
              formatCurrencyAmount(capitalGains.netCapitalGain)}
          </div>
        </div>
        <div className="social-security-calultor-results">
          <div className="social-result-heading">Capital Gains Tax:</div>
          <div className="social-result-value">
            {capitalGains.capitalGainsTax &&
              formatCurrencyAmount(capitalGains.capitalGainsTax)}
          </div>
        </div>
        <div className="social-security-calultor-results">
          <div className="social-result-heading">Total Tax Liability:</div>
          <div className="social-result-value">
            {capitalGains.totalTaxLiability &&
              formatCurrencyAmount(capitalGains.totalTaxLiability)}
          </div>
        </div>
      </div> */}
      <div className="calculation-breakdown">
        <h2 className="text-xl font-bold mb-4">Calculation Breakdown</h2>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">Annual Gross Income:</div>
          <div className="social-result-value">
            {data.grossIncome && formatCurrencyAmount(data.grossIncome)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">Capital Loss Deduction:</div>
          <div className="social-result-value">
            {data.capLossDeduction !== undefined &&
              (data.capLossDeduction > 0
                ? `-${formatCurrencyAmount(data.capLossDeduction)}`
                : "$0")}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">
            Adjusted Gross Income (AGI):
          </div>
          <div className="social-result-value">
            {data.AGI && formatCurrencyAmount(data.AGI)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">Deduction Type:</div>
          <div className="social-result-value">
            {data.deductionType &&
              `${data.deductionType} ${data.federalDeduction ? `` : ""}`}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">Ordinary Taxable Income:</div>
          <div className="social-result-value">
            {data.ordTaxable && formatCurrencyAmount(data.ordTaxable)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">
            Net Long-Term Capital Gains:
          </div>
          <div className="social-result-value">
            {data.ltcgTaxable !== undefined ?
              formatCurrencyAmount(data.ltcgTaxable) : "$0.00"}
          </div>
        </div>

        <hr className="my-3 border-gray-300" />

        <div className="social-security-calultor-results">
          <div className="social-result-heading">
            Federal Ord. Tax (Pre-Credit):
          </div>
          <div className="social-result-value">
            {data.fedOrdTax && formatCurrencyAmount(data.fedOrdTax)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">Federal LTCG Tax:</div>
          <div className="social-result-value">
            {data.fedLtcgTax ? formatCurrencyAmount(data.fedLtcgTax) : "$0.00"}
          </div>
        </div>

        <div className="social-security-calultor-results text-green-600">
          <div className="social-result-heading">
            (-) Non-Refundable Credits:
          </div>
          <div className="social-result-value">
            {data.nonRefundableCredits > 0
              ? `-${formatCurrencyAmount(data.nonRefundableCredits)}`
              : "$0.00"}
          </div>
        </div>

        <div className="social-security-calultor-results text-green-600">
          <div className="social-result-heading">(-) Child Tax Credit:</div>
          <div className="social-result-value">
            {data.ctc > 0 ? `-${formatCurrencyAmount(data.ctc)}` : "$0.00"}
          </div>
        </div>
         <div className="social-security-calultor-results text-green-600">
          <div className="social-result-heading">No. of Dependents:</div>
          <div className="social-result-value">
            {data.numDependents ? data.numDependents  : "0"}
          </div>
        </div>

        <div className="social-security-calultor-results text-green-600">
          <div className="social-result-heading">(-) Refundable Credits:</div>
          <div className="social-result-value">
            {data.refundableCredits > 0
              ? `-${formatCurrencyAmount(data.refundableCredits)}`
              : "$0.00"}
          </div>
        </div>

        <div className="social-security-calultor-results font-bold border-t border-gray-400 pt-2">
          <div className="social-result-heading">Total Federal Tax:</div>
          <div className="social-result-value">
            {data.fedTax && formatCurrencyAmount(data.fedTax)}
          </div>
        </div>

        <hr className="my-3 border-gray-300" />

        <div className="social-security-calultor-results">
          <div className="social-result-heading">
            State Taxable Income ({data.stateName}):
          </div>
          <div className="social-result-value">
            {data.stateTaxable && formatCurrencyAmount(data.stateTaxable)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">State Tax:</div>
          <div className="social-result-value">
            {data.stateTax && formatCurrencyAmount(data.stateTax)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">
            Local Tax ({data.cityName}):
          </div>
          <div className="social-result-value">
            {data.localTax !== undefined && formatCurrencyAmount(data.localTax)}
          </div>
        </div>

        <div className="social-security-calultor-results">
          <div className="social-result-heading">Payroll Tax (FICA/SE):</div>
          <div className="social-result-value">
            {data.payrollTax && formatCurrencyAmount(data.payrollTax)}
          </div>
        </div>

        <div className="social-security-calultor-results font-bold text-lg border-t-2 border-gray-500 mt-3 pt-2">
          <div className="social-result-heading">Total Tax Liability:</div>
          <div className="social-result-value">
            {data.totalTaxLiability &&
              formatCurrencyAmount(data.totalTaxLiability)}
          </div>
        </div>
      </div>
    </div>
  );
};

// Table Styles
const thStyle = {
  padding: "10px",
  fontFamily: "Poppins",
  borderBottom: "1px solid #ddd",
  fontWeight: "bold",
  color: "black",
  fontSize: "14px",
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: "500",
  color: "#6c757d",
  whiteSpace: "nowrap",
};
